const getFacetKeysForAnalytics = (facetMap) => [...facetMap].map(([key, values]) => {
  if (values.length > 0) {
    return Array.from({ length: values.length }, () => key);
  }
  return [];
}).flat();

export default getFacetKeysForAnalytics;
